import newWindowIcon from "../images/new-window-icon.png";

// External link on the Explore page; used to link
// users to sites like evaluation surveys and survey
// dashboards.
function ExplorePageExtLink(props) {
    return (
        <a 
            className="explore-pg-ext-link"
            href={props.link} 
            target="_blank">
                {props.text}
                <img src={newWindowIcon}/>
            </a>
    )
}

export default ExplorePageExtLink;